import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { useContext, useState, useRef, useEffect, useMemo } from 'react';
import { OverlayContext } from './OverlayProvider.mjs';
import { OverlayController } from './OverlayController.mjs';
import { jsx } from 'react/jsx-runtime';

var elementId = 1;
function useOverlay() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$exitOnUnmount = _ref.exitOnUnmount,
      exitOnUnmount = _ref$exitOnUnmount === void 0 ? true : _ref$exitOnUnmount;

  var context = useContext(OverlayContext);

  if (context == null) {
    throw new Error('useOverlay is only available within OverlayProvider.');
  }

  var mount = context.mount,
      unmount = context.unmount;

  var _useState = useState(function () {
    return String(elementId++);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var overlayRef = useRef(null);
  useEffect(function () {
    return function () {
      if (exitOnUnmount) {
        unmount(id);
      }
    };
  }, [exitOnUnmount, id, unmount]);
  return useMemo(function () {
    return {
      open: function open(overlayElement) {
        mount(id, /*#__PURE__*/jsx(OverlayController // NOTE: state should be reset every time we open an overlay
        , {
          ref: overlayRef,
          overlayElement: overlayElement,
          onExit: function onExit() {
            unmount(id);
          }
        }, Date.now()));
      },
      close: function close() {
        var _overlayRef$current;

        (_overlayRef$current = overlayRef.current) === null || _overlayRef$current === void 0 ? void 0 : _overlayRef$current.close();
      },
      exit: function exit() {
        unmount(id);
      }
    };
  }, [id, mount, unmount]);
}

export { useOverlay };
